import { useState } from 'react';
import { generateReport } from '../../service/ReportService';
import axios from 'axios';

export interface PrintReportButtonProps {
    sessionId: string;
    sessionTitle?: string;
    className?: string;
    onError?: (errorMessage: string) => void;
}

const PrintReportButton = ({ sessionId, sessionTitle, className = '', onError } : PrintReportButtonProps) => {
    const [loading, setLoading] = useState(false);

    const handlePrint = async () => {
        let fileURL = null;
        setLoading(true);
        try {
            const blob = await generateReport(sessionId);
            fileURL = window.URL.createObjectURL(blob);

            const newTab = window.open(fileURL, '_blank');
            if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                // Fallback to download
                const link = document.createElement('a');
                link.href = fileURL;
                const filename = sessionTitle
                    ? `Report-${sessionTitle.replace(/\s+/g, '_')}.pdf`
                    : `Report-${sessionId}.pdf`;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(fileURL);
                fileURL = null;
            }
        } catch (error) {
            if (onError && axios.isAxiosError(error)) {
                const errorMessage = error.response?.data?.userMessage || error.message || 'Failed to download or open PDF. Please try again.';
                onError(errorMessage);
            }
            if (fileURL) window.URL.revokeObjectURL(fileURL);
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            onClick={handlePrint}
            className={`gradient-bg hover:opacity-90 text-white text-xs font-semibold py-1.5 px-3 rounded-lg transition ${className}`}
            title="Download Pdf Report"
            disabled={loading}
        >
            <i className="fas fa-download mr-1"></i>
            {loading ? 'Downloading...' : 'Download'}
        </button>
    );
};

export default PrintReportButton;